function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "times") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M32,16.05a3,3,0,1,1-3-3A3,3,0,0,1,32,16.05Z",
    style: {
      fill: "#a0a0a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.81,17.29a1,1,0,0,1,.31,1.31L31,23.79a1,1,0,0,1-1.34,0h0a1,1,0,0,1-.31-1.31l4.09-5.19a1,1,0,0,1,1.35,0Z",
    style: {
      fill: "#a0a0a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.16,17.3a1,1,0,0,0-.31,1.31L27,23.8a1,1,0,0,0,1.34,0h0a1,1,0,0,0,.31-1.31L24.51,17.3a1,1,0,0,0-1.35,0Z",
    style: {
      fill: "#a0a0a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.41,25.58a1,1,0,0,1,1,1l-.14,7.33a1,1,0,0,1-1.07.91h0a1,1,0,0,1-1-1l.14-7.33a1,1,0,0,1,1.07-.91Z",
    style: {
      fill: "#a0a0a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.61,25.58a1,1,0,0,0-1.05,1l.11,7.34a1,1,0,0,0,1.07.9h0a1,1,0,0,0,1-1l-.11-7.34a1,1,0,0,0-1.06-.9Z",
    style: {
      fill: "#a0a0a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.22,24c0,2.32-1.45,4.2-3.24,4.2s-3.24-1.88-3.24-4.2,1.45-4.21,3.24-4.21S32.22,21.72,32.22,24Z",
    style: {
      fill: "#a0a0a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,28a6.07,6.07,0,0,1-.35-.83,11.51,11.51,0,0,1-18.77-8.8,11.51,11.51,0,0,1,21.1-6.23,4.34,4.34,0,0,1,4.22.23,15.09,15.09,0,1,0-6.27,19.06Z",
    style: {
      fill: "#a0a0a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,19.26a1.62,1.62,0,0,1-.33-1.2,1.88,1.88,0,0,1,.16-.56c-.57-.12-1.16-.22-1.76-.29a24.68,24.68,0,0,0-2.05-7.72,24.29,24.29,0,0,0-2.12,9.36c0,.07,0,.13,0,.21a2.86,2.86,0,0,0,0,.41,2.06,2.06,0,0,0,.58,1.68,1.64,1.64,0,0,0,1.52.64,1.53,1.53,0,0,0,.38,0h.18a16.34,16.34,0,0,0,4.84-.8Z",
    style: {
      fill: "#a0a0a0"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimes);
export default __webpack_public_path__ + "static/media/times.82b72dd1fa3e3c5d7858a7e3b3e4b833.svg";
export { ForwardRef as ReactComponent };